/**
 * Created by prog2 on 25/10/2018.
 */

import castellano from './castellano';
import catala from './catala';
import deutsch from './deutsch';
import english from './english';
import euskara from './euskara';
import français from './français';
import nederlands from './nederlands';
import galego from './galego';
import pусский from './pусский';


const messages = {
    Castellano: castellano,
	Català: catala,
    Deutsch: deutsch,
    English: english,
    Euskara: euskara,
    Français: français,
    Galego: galego,
    Nederlands: nederlands,
    Pусский: pусский,
}



export default messages;



// WEBPACK FOOTER //
// ./src/data/i18n/i18n.js